import { camelCaseToTitleCase } from '@caresend/utils';
import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../layout/InfoSubtitle.vue.js';
import TransitionExpand from '../../transitions/TransitionExpand/TransitionExpand.js';

var script = defineComponent({
    name: 'Radio',
    components: {
        InfoSubtitle: __vue_component__,
        TransitionExpand,
    },
    model: {
        prop: 'selected',
        event: 'change',
    },
    props: {
        alwaysShowContentSlot: Boolean,
        disabled: Boolean,
        label: {
            type: String,
            default: null,
        },
        options: {
            type: Array,
            default: () => [],
        },
        radioStyle: {
            type: String,
            default: 'default',
        },
        selected: {
            type: String,
            default: null,
        },
        vertical: {
            type: Boolean,
            default: false,
        },
        formatCamelCaseLabel: {
            type: Boolean,
            default: false,
        },
        displayOptionLabelAsBold: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit, slots }) {
        const selectedOptionID = computed(() => props.selected);
        const radioOptions = computed(() => {
            if (typeof props.options[0] === 'string') {
                const stringOptions = props.options;
                return stringOptions.map((optionString) => ({
                    id: optionString,
                    label: props.formatCamelCaseLabel ? camelCaseToTitleCase(optionString) : optionString,
                }));
            }
            return props.options;
        });
        const classNames = computed(() => {
            const names = [];
            switch (props.radioStyle) {
                case 'card':
                    names.push('Radio--card');
                    break;
            }
            if (props.vertical)
                names.push('Radio--vertical');
            return names;
        });
        const optionClassNames = (optionID) => {
            const names = [];
            if (optionID === selectedOptionID.value) {
                names.push('Radio__option--selected');
            }
            return names;
        };
        const optionLabelClass = computed(() => {
            const names = [];
            if (props.displayOptionLabelAsBold) {
                names.push('Radio__option-bold-label');
            }
            return names;
        });
        const showContentSlot = (option) => {
            var _a;
            const slotForOptionHasContent = !!((_a = slots === null || slots === void 0 ? void 0 : slots.content) === null || _a === void 0 ? void 0 : _a.call(slots, { option }));
            const optionIsSelected = option.id === selectedOptionID.value;
            return slotForOptionHasContent && (optionIsSelected || props.alwaysShowContentSlot);
        };
        const handleOptionSelected = (optionID) => {
            if (optionID !== selectedOptionID.value) {
                emit('change', optionID);
            }
        };
        /** Prevent conflicting events causing unexpected behaviour for interactive
         * elements such as <select> on Radio cards */
        const stopPropagation = (event) => {
            event.stopPropagation();
        };
        return {
            classNames,
            handleOptionSelected,
            optionClassNames,
            optionLabelClass,
            radioOptions,
            selectedOptionID,
            showContentSlot,
            stopPropagation,
        };
    },
});

export { script as default };
